import type { Locale } from "../types";

export const siteCopy: Partial<Record<Locale, Record<string, string>>> = {
  en: {
    brand: "TextPolish",
    navLabel: "Primary navigation",
    languageLabel: "Language",
    home: "Home",
    allTools: "All tools",
    footer:
      "TextPolish Tools helps you edit responsibly. Review AI output before publishing, submitting, or sending.",
    privacy: "Privacy",
    terms: "Terms",
    contact: "Contact",
    extension: "Extension",
    pricing: "Pricing",
    notFoundTitle: "Page not found",
    notFoundBody: "The tool or page you requested does not exist.",
    returnHome: "Return home"
  },
  zh: {
    brand: "TextPolish",
    navLabel: "主导航",
    languageLabel: "语言",
    home: "首页",
    allTools: "全部工具",
    footer: "TextPolish Tools 帮你负责任地编辑文本。发布、提交或发送前，请人工检查 AI 输出。",
    privacy: "隐私",
    terms: "条款",
    contact: "联系",
    extension: "浏览器插件",
    pricing: "定价",
    notFoundTitle: "页面不存在",
    notFoundBody: "你访问的工具或页面不存在。",
    returnHome: "返回首页"
  },
  es: {
    brand: "TextPolish",
    navLabel: "Navegación principal",
    languageLabel: "Idioma",
    home: "Inicio",
    allTools: "Herramientas",
    footer: "TextPolish Tools te ayuda a editar con responsabilidad. Revisa la salida de IA antes de publicar o enviar.",
    privacy: "Privacidad",
    terms: "Términos",
    contact: "Contacto",
    notFoundTitle: "Página no encontrada",
    notFoundBody: "La herramienta o página solicitada no existe.",
    returnHome: "Volver al inicio"
  },
  fr: {
    brand: "TextPolish",
    navLabel: "Navigation principale",
    languageLabel: "Langue",
    home: "Accueil",
    allTools: "Outils",
    footer: "TextPolish Tools vous aide à éditer avec soin. Relisez le résultat IA avant publication ou envoi.",
    privacy: "Confidentialité",
    terms: "Conditions",
    contact: "Contact",
    notFoundTitle: "Page introuvable",
    notFoundBody: "L'outil ou la page demandé n'existe pas.",
    returnHome: "Retour à l'accueil"
  },
  de: {
    brand: "TextPolish",
    navLabel: "Hauptnavigation",
    languageLabel: "Sprache",
    home: "Start",
    allTools: "Tools",
    footer: "TextPolish Tools hilft dir, verantwortungsvoll zu überarbeiten. Prüfe KI-Ausgaben vor dem Veröffentlichen.",
    privacy: "Datenschutz",
    terms: "Bedingungen",
    contact: "Kontakt",
    notFoundTitle: "Seite nicht gefunden",
    notFoundBody: "Das angeforderte Tool oder die Seite existiert nicht.",
    returnHome: "Zur Startseite"
  },
  ja: {
    brand: "TextPolish",
    navLabel: "メインナビゲーション",
    languageLabel: "言語",
    home: "ホーム",
    allTools: "ツール",
    footer: "TextPolish Tools は責任ある編集を支援します。公開や送信の前に AI 出力を確認してください。",
    privacy: "プライバシー",
    terms: "利用規約",
    contact: "お問い合わせ",
    notFoundTitle: "ページが見つかりません",
    notFoundBody: "指定されたツールまたはページは存在しません。",
    returnHome: "ホームに戻る"
  },
  ko: {
    brand: "TextPolish",
    navLabel: "기본 탐색",
    languageLabel: "언어",
    home: "홈",
    allTools: "도구",
    footer: "TextPolish Tools는 책임 있는 편집을 돕습니다. 게시하거나 보내기 전에 AI 결과를 확인하세요.",
    privacy: "개인정보",
    terms: "약관",
    contact: "문의",
    notFoundTitle: "페이지를 찾을 수 없습니다",
    notFoundBody: "요청한 도구나 페이지가 존재하지 않습니다.",
    returnHome: "홈으로 돌아가기"
  },
  pt: {
    brand: "TextPolish",
    navLabel: "Navegação principal",
    languageLabel: "Idioma",
    home: "Início",
    allTools: "Ferramentas",
    footer: "TextPolish Tools ajuda você a editar com responsabilidade. Revise a saída da IA antes de publicar ou enviar.",
    privacy: "Privacidade",
    terms: "Termos",
    contact: "Contato",
    notFoundTitle: "Página não encontrada",
    notFoundBody: "A ferramenta ou página solicitada não existe.",
    returnHome: "Voltar ao início"
  },
  it: {
    brand: "TextPolish",
    navLabel: "Navigazione principale",
    languageLabel: "Lingua",
    home: "Home",
    allTools: "Strumenti",
    footer: "TextPolish Tools ti aiuta a modificare con responsabilità. Controlla l'output IA prima di pubblicare o inviare.",
    privacy: "Privacy",
    terms: "Termini",
    contact: "Contatto",
    notFoundTitle: "Pagina non trovata",
    notFoundBody: "Lo strumento o la pagina richiesta non esiste.",
    returnHome: "Torna alla home"
  },
  ru: {
    brand: "TextPolish",
    navLabel: "Основная навигация",
    languageLabel: "Язык",
    home: "Главная",
    allTools: "Инструменты",
    footer: "TextPolish Tools помогает редактировать ответственно. Проверяйте результат ИИ перед публикацией или отправкой.",
    privacy: "Конфиденциальность",
    terms: "Условия",
    contact: "Контакты",
    notFoundTitle: "Страница не найдена",
    notFoundBody: "Запрошенный инструмент или страница не существует.",
    returnHome: "На главную"
  },
  ar: {
    brand: "TextPolish",
    navLabel: "التنقل الرئيسي",
    languageLabel: "اللغة",
    home: "الرئيسية",
    allTools: "الأدوات",
    footer: "تساعدك TextPolish Tools على التحرير بمسؤولية. راجع مخرجات الذكاء الاصطناعي قبل النشر أو الإرسال.",
    privacy: "الخصوصية",
    terms: "الشروط",
    contact: "اتصال",
    notFoundTitle: "الصفحة غير موجودة",
    notFoundBody: "الأداة أو الصفحة المطلوبة غير موجودة.",
    returnHome: "العودة للرئيسية"
  },
  hi: {
    brand: "TextPolish",
    navLabel: "मुख्य नेविगेशन",
    languageLabel: "भाषा",
    home: "होम",
    allTools: "टूल्स",
    footer: "TextPolish Tools जिम्मेदारी से संपादन में मदद करता है। प्रकाशित या भेजने से पहले AI आउटपुट की जांच करें।",
    privacy: "गोपनीयता",
    terms: "शर्तें",
    contact: "संपर्क",
    notFoundTitle: "पेज नहीं मिला",
    notFoundBody: "अनुरोधित टूल या पेज मौजूद नहीं है।",
    returnHome: "होम पर लौटें"
  }
};

export const homeCopy: Partial<Record<Locale, Record<string, string | string[]>>> = {
  en: {
    title: "TextPolish Tools - Fast AI Text Tools",
    metaDescription:
      "Fast AI text tools for natural writing, readability, tone conversion, word counting, and summaries.",
    eyebrow: "Practical writing tools",
    h1: "Make writing clearer, more natural, and ready to publish.",
    lead:
      "Use focused, single-purpose tools for checking generic phrasing, naturalizing drafts, improving readability, changing tone, counting words, and summarizing long text.",
    searchPlaceholder: "Search text tools",
    searchLabel: "Search tools",
    proof: ["No account required", "Instant text metrics", "AI-assisted editing", "Major languages"],
    allTools: "All tools",
    workflowTitle: "Go from rough draft to clearer writing",
    workflow:
      "Paste your text, check the basic signals, choose the edit you need, then review and copy the version that fits your audience.",
    toolSection: "Choose a tool",
    geoTitle: "Clear help for everyday writing",
    geoBody:
      "Use these tools when a draft feels too stiff, too long, too vague, or hard to scan. You stay in control of what changes and what gets published."
  },
  zh: {
    title: "TextPolish Tools - 快速 AI 文本工具",
    metaDescription: "快速 AI 文本工具，支持文本自然化、可读性优化、语气转换、字数统计和摘要生成。",
    eyebrow: "实用文本工具",
    h1: "让文字更清楚、更自然，并准备好发布。",
    lead:
      "使用单一功能、目标明确的工具检查套话、自然化草稿、优化可读性、转换语气、统计字数，并总结长文本。",
    searchPlaceholder: "搜索文本工具",
    searchLabel: "搜索工具",
    proof: ["无需账号", "即时文本指标", "AI 辅助编辑", "支持主流语种"],
    allTools: "全部工具",
    workflowTitle: "从粗糙草稿改到清楚版本",
    workflow:
      "粘贴文本，先看基础指标，再选择需要的编辑方式。检查结果后，只复制真正适合读者的版本。",
    toolSection: "选择工具",
    geoTitle: "帮你处理日常写作问题",
    geoBody:
      "当草稿显得生硬、太长、太空泛或不好扫读时，可以用这些工具快速找到问题，并决定哪些修改值得采用。"
  },
  es: {
    title: "TextPolish Tools - Herramientas rápidas de texto con IA",
    metaDescription: "Herramientas de texto con IA para naturalizar, mejorar legibilidad, cambiar tono, contar palabras y resumir.",
    eyebrow: "Herramientas prácticas de escritura",
    h1: "Haz que tu texto sea más claro, natural y listo para publicar.",
    lead: "Usa herramientas enfocadas para revisar frases genéricas, naturalizar borradores, mejorar legibilidad, cambiar tono, contar palabras y resumir textos largos.",
    searchPlaceholder: "Buscar herramientas",
    searchLabel: "Buscar herramientas",
    proof: ["Sin cuenta", "Métricas instantáneas", "Edición asistida por IA", "Idiomas principales"],
    allTools: "Todas las herramientas",
    workflowTitle: "De borrador a versión clara",
    workflow: "Pega tu texto, revisa las señales básicas, elige la edición que necesitas y copia la versión que mejor encaje con tu audiencia.",
    toolSection: "Elige una herramienta",
    geoTitle: "Ayuda clara para escribir cada día",
    geoBody: "Úsalo cuando un borrador suene rígido, largo, vago o difícil de leer. Tú decides qué cambios conservar."
  },
  fr: {
    title: "TextPolish Tools - Outils de texte IA rapides",
    metaDescription: "Outils IA pour rendre un texte naturel, lisible, ajuster le ton, compter les mots et résumer.",
    eyebrow: "Outils d'écriture pratiques",
    h1: "Rendez vos textes plus clairs, naturels et prêts à publier.",
    lead: "Utilisez des outils ciblés pour repérer les formulations génériques, naturaliser un brouillon, améliorer la lisibilité, changer le ton, compter les mots et résumer.",
    searchPlaceholder: "Rechercher des outils",
    searchLabel: "Rechercher des outils",
    proof: ["Sans compte", "Mesures instantanées", "Édition assistée par IA", "Langues principales"],
    allTools: "Tous les outils",
    workflowTitle: "Du brouillon à une version claire",
    workflow: "Collez votre texte, vérifiez les signaux de base, choisissez l'édition nécessaire, puis copiez la version adaptée à votre public.",
    toolSection: "Choisir un outil",
    geoTitle: "Une aide claire pour écrire au quotidien",
    geoBody: "Utilisez ces outils lorsqu'un brouillon paraît rigide, trop long, vague ou difficile à parcourir."
  },
  de: {
    title: "TextPolish Tools - Schnelle KI-Texttools",
    metaDescription: "KI-Texttools für natürlichere Texte, bessere Lesbarkeit, Tonwechsel, Wortzählung und Zusammenfassungen.",
    eyebrow: "Praktische Schreibtools",
    h1: "Mache Texte klarer, natürlicher und bereit zur Veröffentlichung.",
    lead: "Nutze fokussierte Tools, um generische Formulierungen zu prüfen, Entwürfe natürlicher zu machen, Lesbarkeit zu verbessern, den Ton zu ändern, Wörter zu zählen und lange Texte zusammenzufassen.",
    searchPlaceholder: "Texttools suchen",
    searchLabel: "Texttools suchen",
    proof: ["Kein Konto nötig", "Sofortige Textwerte", "KI-gestützte Bearbeitung", "Wichtige Sprachen"],
    allTools: "Alle Tools",
    workflowTitle: "Vom Rohentwurf zur klaren Version",
    workflow: "Füge Text ein, prüfe die Basiswerte, wähle die passende Bearbeitung und kopiere nur die Version, die zu deinem Publikum passt.",
    toolSection: "Tool auswählen",
    geoTitle: "Klare Hilfe für tägliches Schreiben",
    geoBody: "Nutze die Tools, wenn ein Entwurf steif, zu lang, vage oder schwer erfassbar wirkt."
  },
  ja: {
    title: "TextPolish Tools - 高速 AI テキストツール",
    metaDescription: "文章の自然化、読みやすさ改善、トーン変換、文字数確認、要約のための AI テキストツール。",
    eyebrow: "実用的な文章ツール",
    h1: "文章をより明確に、自然に、公開できる形へ。",
    lead: "定型的な表現の確認、自然な書き換え、読みやすさ改善、トーン変換、文字数確認、長文要約を目的別に使えます。",
    searchPlaceholder: "ツールを検索",
    searchLabel: "ツールを検索",
    proof: ["アカウント不要", "即時テキスト指標", "AI 編集支援", "主要言語に対応"],
    allTools: "すべてのツール",
    workflowTitle: "粗い下書きから読みやすい文章へ",
    workflow: "テキストを貼り付け、基本指標を確認し、必要な編集を選び、読者に合う版だけをコピーします。",
    toolSection: "ツールを選ぶ",
    geoTitle: "日常の文章作成をわかりやすく支援",
    geoBody: "硬い、長い、曖昧、読みにくい下書きの問題点を素早く見つけ、採用する修正を自分で選べます。"
  },
  ko: {
    title: "TextPolish Tools - 빠른 AI 텍스트 도구",
    metaDescription: "자연스러운 문장, 가독성 개선, 톤 변환, 단어 수 계산, 요약을 위한 AI 텍스트 도구.",
    eyebrow: "실용적인 글쓰기 도구",
    h1: "글을 더 명확하고 자연스럽게, 게시하기 좋게 만드세요.",
    lead: "상투적 표현 확인, 자연스러운 수정, 가독성 개선, 톤 변환, 단어 수 계산, 긴 글 요약을 목적별로 사용할 수 있습니다.",
    searchPlaceholder: "도구 검색",
    searchLabel: "도구 검색",
    proof: ["계정 불필요", "즉시 텍스트 지표", "AI 편집 지원", "주요 언어 지원"],
    allTools: "모든 도구",
    workflowTitle: "초안에서 명확한 버전으로",
    workflow: "텍스트를 붙여넣고 기본 지표를 확인한 뒤 필요한 편집을 선택하고 독자에게 맞는 버전만 복사하세요.",
    toolSection: "도구 선택",
    geoTitle: "일상 글쓰기를 위한 명확한 도움",
    geoBody: "초안이 딱딱하거나 길거나 모호하거나 읽기 어려울 때 빠르게 문제를 찾고 수정 여부를 선택하세요."
  },
  pt: {
    title: "TextPolish Tools - Ferramentas rápidas de texto com IA",
    metaDescription: "Ferramentas de IA para naturalizar, melhorar legibilidade, mudar tom, contar palavras e resumir.",
    eyebrow: "Ferramentas práticas de escrita",
    h1: "Deixe seu texto mais claro, natural e pronto para publicar.",
    lead: "Use ferramentas focadas para revisar frases genéricas, naturalizar rascunhos, melhorar a legibilidade, mudar o tom, contar palavras e resumir textos longos.",
    searchPlaceholder: "Buscar ferramentas",
    searchLabel: "Buscar ferramentas",
    proof: ["Sem conta", "Métricas instantâneas", "Edição com IA", "Idiomas principais"],
    allTools: "Todas as ferramentas",
    workflowTitle: "Do rascunho à versão clara",
    workflow: "Cole o texto, veja os sinais básicos, escolha a edição necessária e copie a versão adequada ao público.",
    toolSection: "Escolha uma ferramenta",
    geoTitle: "Ajuda clara para escrever todos os dias",
    geoBody: "Use quando um rascunho parecer rígido, longo, vago ou difícil de ler."
  },
  it: {
    title: "TextPolish Tools - Strumenti di testo IA rapidi",
    metaDescription: "Strumenti IA per rendere naturale il testo, migliorare leggibilità, cambiare tono, contare parole e riassumere.",
    eyebrow: "Strumenti pratici di scrittura",
    h1: "Rendi il testo più chiaro, naturale e pronto da pubblicare.",
    lead: "Usa strumenti mirati per controllare frasi generiche, naturalizzare bozze, migliorare leggibilità, cambiare tono, contare parole e riassumere testi lunghi.",
    searchPlaceholder: "Cerca strumenti",
    searchLabel: "Cerca strumenti",
    proof: ["Nessun account", "Metriche istantanee", "Editing assistito da IA", "Lingue principali"],
    allTools: "Tutti gli strumenti",
    workflowTitle: "Da bozza grezza a versione chiara",
    workflow: "Incolla il testo, controlla i segnali base, scegli la modifica necessaria e copia la versione più adatta al pubblico.",
    toolSection: "Scegli uno strumento",
    geoTitle: "Aiuto chiaro per la scrittura quotidiana",
    geoBody: "Usalo quando una bozza sembra rigida, troppo lunga, vaga o difficile da leggere."
  },
  ru: {
    title: "TextPolish Tools - Быстрые AI-инструменты для текста",
    metaDescription: "AI-инструменты для естественного текста, читаемости, смены тона, подсчета слов и резюме.",
    eyebrow: "Практичные инструменты письма",
    h1: "Сделайте текст яснее, естественнее и готовым к публикации.",
    lead: "Используйте отдельные инструменты для проверки шаблонных фраз, естественной переработки, улучшения читаемости, смены тона, подсчета слов и резюме.",
    searchPlaceholder: "Искать инструменты",
    searchLabel: "Искать инструменты",
    proof: ["Без аккаунта", "Мгновенные метрики", "Редактирование с ИИ", "Основные языки"],
    allTools: "Все инструменты",
    workflowTitle: "От черновика к ясной версии",
    workflow: "Вставьте текст, проверьте базовые показатели, выберите нужную правку и скопируйте версию для вашей аудитории.",
    toolSection: "Выберите инструмент",
    geoTitle: "Понятная помощь для ежедневного письма",
    geoBody: "Используйте, когда черновик звучит сухо, слишком длинно, расплывчато или трудно читается."
  },
  ar: {
    title: "TextPolish Tools - أدوات نصوص سريعة بالذكاء الاصطناعي",
    metaDescription: "أدوات لتحسين طبيعية النص والوضوح والنبرة وعد الكلمات والتلخيص.",
    eyebrow: "أدوات كتابة عملية",
    h1: "اجعل النص أوضح وأكثر طبيعية وجاهزًا للنشر.",
    lead: "استخدم أدوات مخصصة لفحص العبارات العامة، وتطبيع المسودات، وتحسين الوضوح، وتغيير النبرة، وعد الكلمات، وتلخيص النصوص الطويلة.",
    searchPlaceholder: "ابحث عن الأدوات",
    searchLabel: "ابحث عن الأدوات",
    proof: ["لا حاجة لحساب", "مقاييس فورية", "تحرير بمساعدة الذكاء الاصطناعي", "اللغات الرئيسية"],
    allTools: "كل الأدوات",
    workflowTitle: "من مسودة أولية إلى نص واضح",
    workflow: "الصق النص، راجع المؤشرات الأساسية، اختر نوع التحرير، ثم انسخ النسخة الأنسب لجمهورك.",
    toolSection: "اختر أداة",
    geoTitle: "مساعدة واضحة للكتابة اليومية",
    geoBody: "استخدمها عندما تبدو المسودة جامدة أو طويلة أو غامضة أو صعبة القراءة."
  },
  hi: {
    title: "TextPolish Tools - तेज AI टेक्स्ट टूल्स",
    metaDescription: "स्वाभाविक लेखन, पठनीयता, टोन बदलने, शब्द गिनने और सारांश के लिए AI टेक्स्ट टूल्स।",
    eyebrow: "व्यावहारिक लेखन टूल्स",
    h1: "लेखन को साफ, स्वाभाविक और प्रकाशित करने योग्य बनाएं।",
    lead: "सामान्य वाक्यांश जांचने, ड्राफ्ट को स्वाभाविक बनाने, पठनीयता सुधारने, टोन बदलने, शब्द गिनने और लंबे पाठ का सार बनाने के लिए केंद्रित टूल्स इस्तेमाल करें।",
    searchPlaceholder: "टूल खोजें",
    searchLabel: "टूल खोजें",
    proof: ["खाता जरूरी नहीं", "तुरंत टेक्स्ट मेट्रिक्स", "AI-सहायता संपादन", "मुख्य भाषाएं"],
    allTools: "सभी टूल्स",
    workflowTitle: "कच्चे ड्राफ्ट से साफ लेखन तक",
    workflow: "टेक्स्ट पेस्ट करें, मूल संकेत देखें, जरूरी संपादन चुनें और पाठकों के लिए सही संस्करण कॉपी करें।",
    toolSection: "टूल चुनें",
    geoTitle: "रोजमर्रा के लेखन के लिए साफ मदद",
    geoBody: "जब ड्राफ्ट कठोर, लंबा, अस्पष्ट या पढ़ने में कठिन लगे, तो जल्दी समस्या पहचानें और उपयोगी बदलाव चुनें।"
  }
};

export const workspaceCopy: Partial<Record<Locale, Record<string, string | string[]>>> = {
  en: {
    sample: "Use sample",
    clear: "Clear",
    copy: "Copy result",
    copied: "Copied",
    working: "Working...",
    modeLabel: "Tool mode",
    settingsTitle: "Options",
    inputActionsLabel: "Input helpers",
    sourceLanguageLabel: "Input language",
    targetLanguageLabel: "Output language",
    scenarioLabel: "Writing scenario",
    scenarioGeneral: "General draft",
    scenarioEmail: "Email",
    scenarioAcademic: "Academic",
    scenarioLinkedIn: "LinkedIn post",
    scenarioSupport: "Support reply",
    scenarioProduct: "Product copy",
    autoDetect: "Auto detect",
    keepLanguage: "Keep source language",
    resultTitle: "Result",
    emptyTitle: "Results appear here",
    emptyBody: "Local metrics update as you type. AI actions run only when you choose them.",
    missingText: "Paste some text before running the tool.",
    unavailable: "The AI service is unavailable right now.",
    uploadDocument: "Import file",
    uploadedFile: "Imported {name}",
    importTooLong: "The file was imported and trimmed to {limit} characters for one AI request.",
    importFailed: "This file could not be imported as text.",
    usageCounter: "{used}/{limit} free AI actions today",
    remainingActions: "{count} AI actions left today",
    dailyLimitReached: "You have used the {limit} free AI actions available today. Local metrics and history still work.",
    historyTitle: "History",
    emptyHistory: "Successful runs will be saved locally in this browser.",
    restoredFromHistory: "Restored a previous {tool} result.",
    benchmarkTitle: "Quality benchmark",
    benchmarkBody:
      "Review the output against the same standards users expect from Grammarly, DeepL, and QuillBot: meaning preserved, readable wording, appropriate tone, and no unsupported claims.",
    words: "words",
    chars: "chars",
    sentences: "sentences",
    minRead: "min read",
    readability: "Readability",
    averageSentence: "Average sentence length",
    wordCounterOutput: "This text has {words} words, {characters} characters, {sentences} sentences, and an estimated reading time of {minutes} minute{plural}.",
    qualityTitle: "Review checklist",
    qualityItems: ["Meaning is preserved", "No unsupported facts were added", "Tone matches the audience"]
  },
  zh: {
    sample: "使用示例",
    clear: "清空",
    copy: "复制结果",
    copied: "已复制",
    working: "处理中...",
    modeLabel: "工具模式",
    settingsTitle: "选项",
    inputActionsLabel: "输入辅助",
    sourceLanguageLabel: "输入语言",
    targetLanguageLabel: "输出语言",
    scenarioLabel: "写作场景",
    scenarioGeneral: "通用草稿",
    scenarioEmail: "邮件",
    scenarioAcademic: "论文/学术",
    scenarioLinkedIn: "LinkedIn 帖子",
    scenarioSupport: "客服回复",
    scenarioProduct: "产品文案",
    autoDetect: "自动识别",
    keepLanguage: "保持原语言",
    resultTitle: "结果",
    emptyTitle: "结果会显示在这里",
    emptyBody: "本地指标会随输入即时更新。AI 操作只会在你点击按钮后运行。",
    missingText: "请先粘贴一些文本。",
    unavailable: "AI 服务暂时不可用。",
    uploadDocument: "导入文件",
    uploadedFile: "已导入 {name}",
    importTooLong: "文件已导入，并截取为单次 AI 请求支持的 {limit} 个字符。",
    importFailed: "该文件无法按文本导入。",
    usageCounter: "今日免费 AI 操作 {used}/{limit}",
    remainingActions: "今日剩余 {count} 次 AI 操作",
    dailyLimitReached: "你今天的 {limit} 次免费 AI 操作已用完。本地指标和历史记录仍可使用。",
    historyTitle: "历史记录",
    emptyHistory: "成功运行的结果会保存在当前浏览器本地。",
    restoredFromHistory: "已恢复之前的 {tool} 结果。",
    benchmarkTitle: "质量对照",
    benchmarkBody: "按 Grammarly、DeepL、QuillBot 用户期待的标准检查输出：原意是否保留、表达是否清楚、语气是否适合、是否新增无依据内容。",
    words: "词",
    chars: "字符",
    sentences: "句",
    minRead: "分钟阅读",
    readability: "可读性",
    averageSentence: "平均句长",
    wordCounterOutput: "这段文本有 {words} 个词、{characters} 个字符、{sentences} 个句子，预计阅读时间为 {minutes} 分钟。",
    qualityTitle: "检查清单",
    qualityItems: ["原意是否保留", "是否新增了无依据事实", "语气是否适合读者"]
  },
  es: {
    sample: "Usar ejemplo",
    clear: "Borrar",
    copy: "Copiar resultado",
    copied: "Copiado",
    working: "Trabajando...",
    modeLabel: "Modo",
    sourceLanguageLabel: "Idioma de entrada",
    targetLanguageLabel: "Idioma de salida",
    autoDetect: "Detectar automáticamente",
    keepLanguage: "Mantener idioma original",
    resultTitle: "Resultado",
    emptyTitle: "El resultado aparecerá aquí",
    emptyBody: "Las métricas locales se actualizan al escribir. La IA solo se ejecuta cuando eliges una acción.",
    missingText: "Pega texto antes de ejecutar la herramienta.",
    unavailable: "El servicio de IA no está disponible ahora.",
    words: "palabras",
    chars: "caracteres",
    sentences: "frases",
    minRead: "min de lectura",
    readability: "Legibilidad",
    averageSentence: "Longitud media de frase",
    wordCounterOutput: "Este texto tiene {words} palabras, {characters} caracteres, {sentences} frases y un tiempo de lectura estimado de {minutes} minuto{plural}.",
    qualityTitle: "Lista de revisión",
    qualityItems: ["El significado se conserva", "No se añadieron hechos sin base", "El tono encaja con la audiencia"]
  },
  ja: {
    sample: "例を使う",
    clear: "クリア",
    copy: "結果をコピー",
    copied: "コピー済み",
    working: "処理中...",
    modeLabel: "モード",
    sourceLanguageLabel: "入力言語",
    targetLanguageLabel: "出力言語",
    autoDetect: "自動検出",
    keepLanguage: "元の言語を維持",
    resultTitle: "結果",
    emptyTitle: "結果はここに表示されます",
    emptyBody: "入力中にローカル指標が更新されます。AI はボタンを押したときだけ実行されます。",
    missingText: "ツールを実行する前に文章を貼り付けてください。",
    unavailable: "現在 AI サービスを利用できません。",
    words: "語",
    chars: "文字",
    sentences: "文",
    minRead: "分で読了",
    readability: "読みやすさ",
    averageSentence: "平均文長",
    wordCounterOutput: "この文章は {words} 語、{characters} 文字、{sentences} 文で、読了時間は約 {minutes} 分です。",
    qualityTitle: "確認リスト",
    qualityItems: ["意味が保たれている", "根拠のない事実が追加されていない", "読者に合うトーンになっている"]
  },
  ar: {
    sample: "استخدم مثالًا",
    clear: "مسح",
    copy: "نسخ النتيجة",
    copied: "تم النسخ",
    working: "جارٍ العمل...",
    modeLabel: "الوضع",
    sourceLanguageLabel: "لغة الإدخال",
    targetLanguageLabel: "لغة الإخراج",
    autoDetect: "اكتشاف تلقائي",
    keepLanguage: "الحفاظ على لغة المصدر",
    resultTitle: "النتيجة",
    emptyTitle: "ستظهر النتائج هنا",
    emptyBody: "تتحدث المقاييس المحلية أثناء الكتابة. تعمل إجراءات الذكاء الاصطناعي فقط عند اختيارها.",
    missingText: "الصق نصًا قبل تشغيل الأداة.",
    unavailable: "خدمة الذكاء الاصطناعي غير متاحة الآن.",
    words: "كلمات",
    chars: "حروف",
    sentences: "جمل",
    minRead: "دقيقة قراءة",
    readability: "قابلية القراءة",
    averageSentence: "متوسط طول الجملة",
    wordCounterOutput: "يحتوي هذا النص على {words} كلمة و{characters} حرفًا و{sentences} جملة، ووقت قراءة تقديري {minutes} دقيقة.",
    qualityTitle: "قائمة المراجعة",
    qualityItems: ["المعنى محفوظ", "لم تُضف حقائق بلا دليل", "النبرة مناسبة للجمهور"]
  }
};

export const toolPageCopy: Partial<Record<Locale, Record<string, string | string[]>>> = {
  en: {
    howToTitle: "How to use {tool}",
    howToBody:
      "Paste text you have permission to edit, choose the mode that matches your goal, and review the result before using it. Local metrics are calculated in your browser. AI-powered edits run only after you press the action button.",
    bestForTitle: "Best for",
    bestForItems: ["Draft review before publishing", "Email, article, and post editing", "Quick text quality checks"],
    responsibleTitle: "Responsible use",
    responsibleBody:
      "These tools improve writing quality. They do not prove authorship, bypass institutional rules, or replace human judgment.",
    relatedTitle: "Related tools",
    faqTitle: "FAQ",
    sponsored: "Sponsored placement"
  },
  zh: {
    howToTitle: "如何使用 {tool}",
    howToBody:
      "粘贴你有权限编辑的文本，选择符合目标的模式，并在使用前检查结果。本地指标在浏览器内计算。AI 编辑只会在你点击操作按钮后运行。",
    bestForTitle: "适合场景",
    bestForItems: ["发布前检查草稿", "编辑邮件、文章和帖子", "快速检查文本质量"],
    responsibleTitle: "负责任使用",
    responsibleBody: "这些工具用于提升写作质量。它们不能证明作者身份、规避机构规则，也不能取代人工判断。",
    relatedTitle: "相关工具",
    faqTitle: "常见问题",
    sponsored: "赞助位"
  },
  es: {
    howToTitle: "Cómo usar {tool}",
    howToBody: "Pega texto que tengas permiso para editar, elige el modo adecuado y revisa el resultado antes de usarlo. Las métricas locales se calculan en tu navegador y las ediciones con IA solo se ejecutan al pulsar el botón.",
    bestForTitle: "Ideal para",
    bestForItems: ["Revisar borradores antes de publicar", "Editar correos, artículos y publicaciones", "Comprobar calidad de texto rápidamente"],
    responsibleTitle: "Uso responsable",
    responsibleBody: "Estas herramientas mejoran la calidad del texto. No prueban autoría ni reemplazan el juicio humano.",
    relatedTitle: "Herramientas relacionadas",
    faqTitle: "Preguntas frecuentes",
    sponsored: "Ubicación patrocinada"
  },
  ja: {
    howToTitle: "{tool} の使い方",
    howToBody: "編集する権利のある文章を貼り付け、目的に合うモードを選び、使用前に結果を確認してください。ローカル指標はブラウザ内で計算され、AI 編集はボタンを押したときだけ実行されます。",
    bestForTitle: "おすすめ用途",
    bestForItems: ["公開前の下書き確認", "メール、記事、投稿の編集", "文章品質の素早い確認"],
    responsibleTitle: "責任ある使用",
    responsibleBody: "これらのツールは文章品質を高めるためのものです。著者判定を保証したり、人の判断を置き換えたりするものではありません。",
    relatedTitle: "関連ツール",
    faqTitle: "よくある質問",
    sponsored: "スポンサー枠"
  },
  ar: {
    howToTitle: "كيفية استخدام {tool}",
    howToBody: "الصق نصًا لديك إذن بتعديله، واختر الوضع المناسب، وراجع النتيجة قبل استخدامها. تُحسب المقاييس محليًا في المتصفح، وتعمل تعديلات الذكاء الاصطناعي فقط بعد الضغط على زر الإجراء.",
    bestForTitle: "مناسب لـ",
    bestForItems: ["مراجعة المسودات قبل النشر", "تحرير الرسائل والمقالات والمنشورات", "فحص جودة النص بسرعة"],
    responsibleTitle: "استخدام مسؤول",
    responsibleBody: "تحسن هذه الأدوات جودة الكتابة. لا تثبت هوية الكاتب ولا تستبدل الحكم البشري.",
    relatedTitle: "أدوات ذات صلة",
    faqTitle: "أسئلة شائعة",
    sponsored: "مساحة إعلانية"
  }
};

export const staticPages = {
  privacy: {
    en: {
      title: "Privacy Policy",
      body: [
        "TextPolish Tools is designed to process pasted text only when you choose to run a tool.",
        "The production launch does not create accounts or store pasted text.",
        "AI-powered actions may send your text to the configured AI provider to generate a response.",
        "Advertising and analytics providers may process standard browser and usage signals according to their own policies."
      ]
    },
    zh: {
      title: "隐私政策",
      body: [
        "TextPolish Tools 只会在你主动运行工具时处理粘贴的文本。",
        "当前生产版本不创建账号，也不保存你粘贴的文本。",
        "AI 功能可能会将文本发送给已配置的 AI 服务商以生成结果。",
        "广告和分析服务商可能会按照各自政策处理标准浏览器与使用信号。"
      ]
    }
  },
  terms: {
    en: {
      title: "Terms",
      body: [
        "Use TextPolish Tools for text you own or have permission to edit.",
        "AI output should be reviewed before publication, submission, or business use.",
        "The tools provide writing assistance and quality signals, not guaranteed authorship or authenticity determinations."
      ]
    },
    zh: {
      title: "使用条款",
      body: [
        "请仅将 TextPolish Tools 用于你拥有或有权限编辑的文本。",
        "AI 输出在发布、提交或商业使用前都应经过人工检查。",
        "这些工具提供写作辅助和质量信号，不提供确定性的作者身份或真实性判断。"
      ]
    }
  },
  contact: {
    en: {
      title: "Contact",
      body: ["For product, privacy, or advertising questions, contact the site operator at hello@textpolish.tools."]
    },
    zh: {
      title: "联系",
      body: ["如有产品、隐私或广告相关问题，请联系网站运营者：hello@textpolish.tools。"]
    }
  },
  extension: {
    en: {
      title: "Browser Extension",
      body: [
        "TextPolish is being built for the places where people already write: email, documents, support tools, social posts, and web forms.",
        "The extension scaffold in this project injects a compact writing panel into editable fields and sends selected text to the production API.",
        "Store publication, extension signing, account sync, and organization policy controls should be connected before a public Chrome Web Store launch."
      ]
    },
    zh: {
      title: "浏览器插件",
      body: [
        "TextPolish 会进入用户已经在写作的地方：邮件、文档、客服系统、社交帖子和网页表单。",
        "当前项目已包含浏览器插件脚手架，可以在可编辑区域注入轻量写作面板，并把选中文本发送到生产 API。",
        "正式发布 Chrome Web Store 前，还需要接入插件签名、账号同步和组织策略控制。"
      ]
    }
  },
  pricing: {
    en: {
      title: "Pricing",
      body: [
        "Free users get local text metrics, document import, history in the browser, and a limited number of AI actions per day.",
        "A paid plan should unlock higher AI volume, saved account history, document workflows, browser extension sync, and team controls.",
        "Real subscriptions require Stripe, Lemon Squeezy, Paddle, or another payment provider plus authenticated usage tracking on the server."
      ]
    },
    zh: {
      title: "定价",
      body: [
        "免费用户可以使用本地文本指标、文档导入、浏览器本地历史记录，以及每日有限次数的 AI 操作。",
        "付费计划应解锁更高 AI 用量、账号级历史记录、文档工作流、浏览器插件同步和团队控制。",
        "真实订阅需要接入 Stripe、Lemon Squeezy、Paddle 或其他支付服务，并在服务端记录认证用量。"
      ]
    }
  }
} as const;

export function getSiteCopy(locale: Locale) {
  return { ...siteCopy.en!, ...(siteCopy[locale] ?? {}) };
}

export function getHomeCopy(locale: Locale) {
  return homeCopy[locale] ?? homeCopy.en!;
}

export function getWorkspaceCopy(locale: Locale) {
  return { ...workspaceCopy.en!, ...(workspaceCopy[locale] ?? {}) };
}

export function getToolPageCopy(locale: Locale) {
  return toolPageCopy[locale] ?? toolPageCopy.en!;
}

export function getStaticPageCopy(page: keyof typeof staticPages, locale: Locale) {
  const localizedPages = staticPages[page] as typeof staticPages[typeof page] & Partial<Record<Locale, { title: string; body: readonly string[] }>>;
  return localizedPages[locale] ?? localizedPages.en;
}
